<div class="pl-1 pr-1" fxLayout="column">
  <div fxFlex>
    <div fxLayout="column" fxLayoutAlign="center center">
      <h1 class="my-1 call-number">
        {{ callNumber | displayPhoneNumber }}
        <div class="crm-logo" *ngIf="activeCRM" (click)="openContactProfile(callNumber)" title="{{activeCRM.name}}">
          <img *ngIf="crmConfig" src="assets/images/{{crmConfig.logo}}" alt="{{activeCRM.type}}">
        </div>
      </h1>

      <h3 class="py-1 full-width mt-0 mb-0 font-weight-normal call-time" fxLayout="row" fxLayout.xs="column"
        fxLayoutAlign="center center" fxLayoutGap="5px" fxLayoutGap.xs="0">
        <ng-container *ngIf="call.user_direction === callDirection.OUTBOUND; then iconCallLogForwardBlock; else iconCallLogBackwardBlock">
        </ng-container>

        <ng-template #iconCallLogForwardBlock>
          <ng-container *ngTemplateOutlet="iconCallForward; context: {callItem: call}"></ng-container>
        </ng-template>
        <ng-template #iconCallLogBackwardBlock>
          <ng-container *ngTemplateOutlet="iconCallBackward; context: {callItem: call}"></ng-container>
        </ng-template>

        <span fxLayoutAlign="center center" class="mx-1">
          <mat-icon>date_range</mat-icon>
          {{ 'datetime.at'|translate: {date:(call.start_time|timeFormatDateMed),
          time:(call.start_time|date:'HH\'h\'mm')} }}
        </span>

        <span fxLayoutAlign="center center" class="mx-1">
          <ng-container *ngIf="shouldDisplayRecall(); else recallTimeBlock">
            <mat-icon>refresh</mat-icon>
            ASAP
          </ng-container>
          <ng-template #recallTimeBlock>
            <ng-container *ngIf="call.recall_time">
              {{ 'datetime.recall_at'|translate: {date:(call.recall_time|timeFormatDateMed),
              time:(call.recall_time|date:'HH\'h\'mm')} }}
            </ng-container>
          </ng-template>
        </span>
      </h3>

      <div fxLayout="row" fxLayoutAlign="center center" class="mt-1 mb-1" fxLayoutAlign="start center"
        fxLayoutGap="10px">
        <ng-container *ngIf="call.user_direction === callDirection.INBOUND && call.voicemail_public_id && isSMSFeatureEnabled">
          <ng-container *ngTemplateOutlet="tplSendSms"></ng-container>
        </ng-container>
        <button class="bt-call" mat-fab (click)="makeCall()" [disabled]="callNumber === 'anonymous'">
          <mat-icon class="mat-text-white">call</mat-icon>
        </button>
        <ng-container *ngIf="call.user_direction === callDirection.INBOUND && call.voicemail_public_id; else tplSendSms">
          <fileentry-player-button [filePublicId]="call.voicemail_public_id" playerId="main"
            (onPlay)="updateListened(call)"></fileentry-player-button>
          {{ 'call.listen_voicemail'|translate }}
        </ng-container>

        <ng-template #tplSendSms>
          <button class="bt-send-sms" data-ci="button-send-sms" mat-icon-button color="accent" (click)="sendSms()" *ngIf="isSMSFeatureEnabled">
            <mat-icon class="mat-text-white">textsms</mat-icon>
          </button>
        </ng-template>
      </div>
    </div>
  </div>

  <mat-list *ngIf="voicemailMessages && voicemailMessages.length">
    <h2 class="pa-1 call-others">{{ 'voicemail.title' | translate }}</h2>
    <ng-container *ngFor="let vm of voicemailMessages; last as last">
      <mat-list-item class="mat-text-muted ma-0">
        <span fxLayoutAlign="center center">
          <mat-icon [color]="vm.is_read ? '': 'warn'">voicemail</mat-icon>&nbsp;
          {{ vm.receive_dt|date:'dd/MM/yyyy HH:mm' }}
          <span fxFlex></span>
        </span>

        <span fxFlex></span>

        <span fxFlex="100px" fxLayoutAlign="start center">
          <fileentry-player-button [filePublicId]="vm.public_id" playerId="main" (onPlay)="voicemailUpdateListened(vm)">
          </fileentry-player-button>
        </span>
      </mat-list-item>
      <mat-divider *ngIf=" !last">
      </mat-divider>
    </ng-container>
  </mat-list>

  <mat-list *ngIf="callList.length">
    <h2 class="pa-1 call-others">{{ 'call.call_history' | translate }}</h2>
    <ng-container *ngFor="let oneCall of callList; last as last">
      <mat-list-item class="mat-text-muted ma-0">
        <ng-container *ngIf="oneCall.user_direction === callDirection.OUTBOUND; then iconCallForwardBlock; else iconCallBackwardBlock">
        </ng-container>

        <ng-template #iconCallForwardBlock>
          <ng-container *ngTemplateOutlet="iconCallForward; context: {callItem: oneCall}"></ng-container>
        </ng-template>
        <ng-template #iconCallBackwardBlock>
          <ng-container *ngTemplateOutlet="iconCallBackward; context: {callItem: oneCall}"></ng-container>
        </ng-template>

        <span fxLayoutAlign="center center">
          <mat-icon>date_range</mat-icon>&nbsp;
          {{ 'datetime.at'|translate: {date:(oneCall.start_time|timeFormatDateMed),
          time:(oneCall.start_time|date:'HH\'h\'mm')} }}
          <span fxFlex></span>
        </span>

        <span fxFlex></span>

        <span fxFlex="100px" fxLayoutAlign="start center">
          <ng-template [ngIf]="!oneCall.is_missed">
            <mat-icon>access_time</mat-icon>
            &nbsp; {{ oneCall.duration | seconds_as_duration }}
          </ng-template>
          <ng-template [ngIf]="oneCall.voicemail_public_id">
            <fileentry-player-button [filePublicId]="oneCall.voicemail_public_id" playerId="main"
              (onPlay)="updateListened(oneCall)">
            </fileentry-player-button>
          </ng-template>
        </span>
      </mat-list-item>
      <mat-divider *ngIf="!last"></mat-divider>
    </ng-container>
  </mat-list>
</div>

<ng-template #MissedCall let-callItem="callItem">
  <ng-template [ngIf]="callItem.is_voicemail" [ngIfElse]="iconMissedBlock">
    <mat-icon [color]="callItem.is_read ? '': 'warn'">
      voicemail
    </mat-icon>
  </ng-template>
  <ng-template #iconMissedBlock>
    <mat-icon class="is-missed">call_missed</mat-icon>
  </ng-template>
</ng-template>

<ng-template #iconCallBackward let-callItem="callItem">
  <ng-container *ngIf="callItem.is_missed == 1 then missedInbound;else noMissedInbound"></ng-container>

  <ng-template #missedInbound>
    <ng-container *ngTemplateOutlet="MissedCall; context: {callItem: callItem}"></ng-container>
  </ng-template>

  <ng-template #noMissedInbound>
    <mat-icon class="call_in">south</mat-icon>
  </ng-template>
</ng-template>

<ng-template #iconCallForward let-callItem="callItem">
  <ng-container *ngIf="callItem.is_missed == 1 then missedOutbound;else noMissedOutbound"></ng-container>

  <ng-template #missedOutbound>
    <ng-container *ngTemplateOutlet="MissedCall; context: {callItem: callItem}"></ng-container>
  </ng-template>

  <ng-template #noMissedOutbound>
    <mat-icon class="mat-text-muted">north</mat-icon>
  </ng-template>
</ng-template>
